module.exports = __webpack_public_path__ + "img/rotateHint_EN.b3768531.png";